import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/app.css";
import "./styles/detail.css";
import "./styles/nebula.css";
import "./styles/reposition.css";
import "./styles/crowdsource.css";
import "./styles/old-photos.css";
import "./styles/old-photo-home.css";
import "./styles/photo-alignment.css";
import "./styles/insight.css";
import "./styles/mobile-shell.css";

createApp(App).use(router).mount("#app");
